export const graphqlUrl = {
  prod: 'https://comet.451.io/graphql',
  dev: 'https://comet-dev.451.io/graphql',
  stage: 'https://comet-stage.451.io/graphql'
};
